import CaptureIcon from "../../../../images/features/homeCards/captureFeatureHome.svg"
import ConvertIcon from "../../../../images/features/homeCards/convertFeatureHome.svg"
import OrganizeIcon from "../../../../images/features/homeCards/organizeFeatureHome.svg"
import EngageIcon from "../../../../images/features/homeCards/engageFeatureHome.svg"

const featuresData = [
  {
    icon: CaptureIcon,
    title: "Capture",
    description:
      "Capture leads from anywhere: websites, text message, social media and calendar bookings.",
    link: "/platform/contact-management",
  },
  {
    icon: ConvertIcon,
    title: "Convert",
    description:
      "Convert leads to customers through dynamic, automated communication sequences.",
    link: "/platform/automation/",
  },
  {
    icon: OrganizeIcon,
    title: "Organize",
    description:
      "Segment Contacts by List, Interest, Tag, Poll Response, Campaign Activity and more.",
    link: "/features/smartlists-and-filters/",
  },
  {
    icon: EngageIcon,
    title: "Engage",
    description:
      "Drive repeat sales through engaging offers, email, text, countdowns and more.",
    link: "/platform/campaigns/",
  },
]

export default featuresData
